export const SEARCH_REQUEST = 'SEARCH_REQUEST'
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS'
export const SEARCH_FAIL = 'SEARCH_FAIL'
export const SEARCH_QUERY = 'SEARCH_QUERY'
export const CATEGORY_CHARACTERISTICS = 'CATEGORY_CHARACTERISTICS'
